export enum ButtonSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
  XXL = 'xxl',
}

export enum ButtonVariant {
  Text = 'text',
  Rounded = 'rounded',
  Round = 'round',
}

export enum ButtonTextColor {
  Ocean = 'ocean',
  Black = 'black',
  Darkgrey = 'darkgray',
}
